
export class Alert {
    type: string | undefined;

    message: string | undefined;

    timeout: number = 0;
}